/**
 * @file Footer
 */

/**
 * Footer component
 */

import { gsap } from 'gsap';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

/**
 * Footer js.
 *
 * @return null
 */
const vFooter = () => {
	const footer = document.querySelector( '.v-footer' );

	if ( ! footer ) {
		return false;
	}

	gsap.registerPlugin( ScrollToPlugin );

	const scrollTop = footer.querySelectorAll( '.v-footer__arrow-link' );

	/**
	 *
	 */
	function scrollUp() {
		gsap.to( window, {
			duration: 1,
			scrollTo: 0,
			ease:     'sine.out',
		} );
	}

	/**
	 * Scroll window
	 *
	 * @param {Function} scrollUp functions to scroll user.
	 */
	[ ...scrollTop ].forEach( ( el ) => {
		el.addEventListener( 'click', scrollUp );
	} );
};

export default vFooter;
